import { z } from "zod";

const PresignedUrlResponseSchema = z.object({ url: z.string() });

export const PresignedDownloadResponseSchema = z.object({ url: z.string(), filename: z.string() });

export type FetchJson = (path: string) => Promise<unknown>;

export function presignedDownloadPath(storageUrl: string, filename: string): string {
  return `/api/presigned-urls?storageUrl=${encodeURIComponent(storageUrl)}&filename=${encodeURIComponent(filename)}`;
}

export async function fetchPresignedDownloadUrl(fetchJson: FetchJson, storageUrl: string, filename: string): Promise<string> {
  return PresignedUrlResponseSchema.parse(await fetchJson(presignedDownloadPath(storageUrl, filename))).url;
}

export function clickDownloadLink(url: string, filename: string): void {
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function downloadStoredObject(fetchJson: FetchJson, storageUrl: string, filename: string): Promise<void> {
  clickDownloadLink(await fetchPresignedDownloadUrl(fetchJson, storageUrl, filename), filename);
}
